import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { infoSection } from "components/contact/InfoSection/common/styles";
import React from "react";

const PRONOUN_TYPES = [
    {
        label: "He, him, his",
        value: "He, him, his",
    },
    {
        label: "She, her, hers",
        value: "She, her, hers",
    },
    {
        label: "They, them, their",
        value: "They, them, their",
    },
    {
        label: "Ze, zir, zirs",
        value: "Ze, zir, zirs",
    },
    {
        label: "Ze, hir, hirs",
        value: "Ze, hir, hirs",
    },
];

function PronounSelect({ disabled, value, onChange, placeholder}) {
    const classes = infoSection();

    function handleChange(e) {
        onChange(e.target.value);
    }
    function handleSelect(e, value) {
        onChange(value);
    }
    return (
        <Autocomplete
            freeSolo
            disabled={disabled}
            className={classes.pronounRoot}
            onChange={handleSelect}
            value={value}
            options={PRONOUN_TYPES.map((option) => option.label)}
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="outlined"
                    margin="normal"
                    disabled={disabled}
                    value={value}
                    onChange={handleChange}
                    placeholder={placeholder}
                />
            )}
        />
    );
}

export default PronounSelect;
